module.exports = __webpack_public_path__ + "img/sldb_logo.02400786.png";